
import { Component, Vue } from 'vue-property-decorator'
import { CommonService } from '@/services'
import FullLoading from '@/components/full_loading/index.vue'
import FeedbackTable from './components/feedback_table.vue'
const typeOptions = {
    Feedback: {
        key: 'feedback',
        title: '反馈意见'
    },
    Include: {
        key: 'include',
        title: '请求收录'
    },
    Data: {
        key: 'data',
        title: '数据纠错'
    }
}

const statusOptions = {
    All: {
        key: null,
        label: '全部'
    },
    Treated: {
        key: 1,
        label: '已处理'
    },
    unTreated: {
        key: 0,
        label: '未处理'
    }
}

@Component({
    name: 'feedback-list',
    components: {
        FullLoading,
        FeedbackTable
    }
})
export default class extends Vue {
    private loading = false
    private typeOptions = typeOptions
    private curType = typeOptions.Feedback.key
    private curStatus = statusOptions.Treated.key
    private list: any[] = []
    private requestMap: any = new Map<string, any>([
        [typeOptions.Feedback.key, this.getFeedbackList],
        [typeOptions.Include.key, this.getIncludeRequestList],
        [typeOptions.Data.key, this.getDataCorrectionList]
    ])
    private updateRequestMap: any = new Map<string, any>([
        [typeOptions.Feedback.key, this.updateFeedback],
        [typeOptions.Include.key, this.updateInclude],
        [typeOptions.Data.key, this.updateDataCorrect]
    ])
    private statusOptions = statusOptions
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0

    private async mounted() {
        await this.getList()
    }

    async getList() {
        this.showLoading()
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize,
            status: this.curStatus
        }
        const result = await this.requestMap.get(this.curType)(params)
        if (result.status === 200) {
            this.list = result.data.list
            this.pageTotal = result.data.page_total
        }
        this.hideLoading()
    }

    async onUpdate(data: any) {
        const params = {
            id: +data.id,
            status: +data.status
        }
        const result = await this.updateRequestMap.get(this.curType)(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '更改成功!' })
            return this.getList()
        }
        this.$message.error(result.message || '设置失败')
        return 
    }

    // 反馈
    async getFeedbackList(params: any) {
        return await CommonService.getFeedbackList(params)
    }

    async updateFeedback(params: any) {
        return await CommonService.updateFeedbackDetail(params)
    }

    // 收录请求
    async getIncludeRequestList(params: any) {
        return await CommonService.getIncludeRequestList(params)
    }

    async updateInclude(params: any) {
        return await CommonService.updateIncludeRequestDetail(params)
    }

    // 数据纠错
    async getDataCorrectionList(params: any) {
        return await CommonService.getDataCorrectionList(params)
    }
    async updateDataCorrect(params: any) {
        return await CommonService.updateDataCorrectionDetail(params)
    }

    onChange() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.getList()
    }

    onStatusChange() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.getList()
    }

    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.getList()
    }

    showLoading() {
        this.loading = true
    }

    hideLoading() {
        this.loading = false
    }
}
